import {
  Box,
  Button,
  Card,
  Dialog,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import React, { FC, useEffect, useState } from 'react';
import PaginationTable from '../common/paginationTable';
import HeadTable from '../common/sortTable/sortTable';
import { BankedPayeeDialog } from './BankedPayeeDialog';
import { useUserPayments } from './hooks/userPayments';
import TablesSearch from '../common/tablesSearch/tablesSearch';
import FilterComponent from '../common/tablesFilter/FilterList';
import { getDate } from '../../helpers/dateHelper';
import moment from 'moment';

interface Props {
  id: string;
}

export const PaymentsTab: FC<Props> = ({ id }) => {
  const {
    state,
    bankedDialog,
    setBankedDialog,
    handleChangeRowsPerPage,
    handleFirstPage,
    handleLastPage,
    handleChangePage,
    handleSort,
    refundPayment,
    sendReceipt,
    applySearch,
    filterDropdown,
    closeFilter,
    dropdown,
    search,
    clearSearch,
    searchState,
    closeBankedDialog,
    filter,
    handleSelectStatus,
    clearSelectedStatus,
    selectedAllStatuts,
    applyStatusFilter,
  } = useUserPayments(id);
  return (
    <>
      <Box marginTop='0.5em'>
        <Card>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell id='active-table-head'>
                    <HeadTable
                      title='GroupId'
                      // filterHandle={filterDropdown}
                    />
                    {/* {dropdown.groupid && (
                      <TablesSearch
                        search={(event) =>
                          search(event.currentTarget.value, 'groupId')
                        }
                        applySearch={() => applySearch('groupId')}
                        searchString={searchState.groupId}
                        clearSearch={() => clearSearch('groupId')}
                      />
                    )} */}
                  </TableCell>
                  {/* <TableCell id='active-table-head'>Payment Type</TableCell> */}
                  <TableCell id='active-table-head'>
                    <HeadTable
                      title='Total Cost'
                      //  sort={handleSort}
                    />
                  </TableCell>
                  <TableCell id='active-table-head'>
                    <HeadTable
                      title='Status'
                      // sort={handleSort}
                      // filterHandle={filterDropdown}
                    />
                    {/* {dropdown.status && (
                      <FilterComponent
                        categories={filter.status}
                        selectedCategories={filter.selectedStatuts}
                        handleSelectedCategory={handleSelectStatus}
                        selectedAllCategories={selectedAllStatuts}
                        clearCategory={clearSelectedStatus}
                        hideSearch={true}
                        appointment=''
                        applyCategoryFilter={applyStatusFilter}
                      />
                    )} */}
                  </TableCell>
                  <TableCell>Order Type</TableCell>
                  <TableCell>Created At</TableCell>
                  {/* <TableCell>Purchase Date</TableCell> */}
                  <TableCell id='active-table-head-actions'>Actions</TableCell>
                </TableRow>
              </TableHead>
              {state.orders.map((item) => {
                const compareDate = item.purchaseDate
                  ? item.purchaseDate
                  : item.createdAt;
                const isOldAPIPayment = moment(compareDate).isSameOrBefore(
                  '2024-02-01T09:00:00'
                );
                return (
                  <TableBody onClick={closeFilter}>
                    <TableCell>{item.groupId}</TableCell>
                    {/* <TableCell>{item.paymentWay}</TableCell> */}
                    <TableCell>{`£ ${(Math.round(item.totalCost) / 100).toFixed(
                      2
                    )}`}</TableCell>
                    <TableCell>{item.paymentStatus}</TableCell>
                    <TableCell>
                      {item.orderType ? item.orderType : '-'}
                    </TableCell>
                    <TableCell>{getDate(new Date(item.createdAt))}</TableCell>
                    {/* <TableCell>
                      {item.purchaseDate
                        ? getDate(new Date(item.purchaseDate))
                        : '-'}
                    </TableCell> */}
                    <TableCell>
                      <div className='actions-table-body'>
                        {item.paymentStatus !== 'REFUNDED' && (
                          <Button
                            className='refund-button'
                            disabled={state.loading}
                            onClick={sendReceipt(item)}
                          >
                            {state.loading && state.refundItem === item.groupId
                              ? 'Sending...'
                              : 'Send receipt'}
                          </Button>
                        )}
                        {item.paymentStatus !== 'REFUNDED' &&
                          !isOldAPIPayment && (
                            <Button
                              className='refund-button'
                              disabled={
                                state.loading ||
                                item.orderType === 'SUBSCRIPTION' ||
                                item.orderType === 'SUBSCRIPTION-VIP' ||
                                !item.totalCost
                              }
                              onClick={refundPayment({
                                ...item,
                                paymentWay: item.paypalId
                                  ? 'PayPal'
                                  : undefined,
                              })}
                            >
                              {state.loading &&
                              state.refundItem === item.groupId
                                ? 'Refunding...'
                                : `${item.paypalId ? 'Paypal' : 'Make'} Refund`}
                            </Button>
                          )}
                        {item.paymentStatus !== 'REFUNDED' &&
                          isOldAPIPayment && (
                            <Button
                              className='refund-button'
                              disabled={
                                state.loading ||
                                item.orderType === 'SUBSCRIPTION' ||
                                item.orderType === 'SUBSCRIPTION-VIP' ||
                                !item.totalCost
                              }
                              onClick={refundPayment({
                                ...item,
                                paymentWay: item.paypalId
                                  ? 'PayPal'
                                  : 'OldCheckout',
                              })}
                            >
                              {state.loading &&
                              state.refundItem === item.groupId
                                ? 'Refunding...'
                                : item.paypalId
                                ? 'Paypal Refund'
                                : 'Old API Refund'}
                            </Button>
                          )}
                      </div>
                    </TableCell>
                  </TableBody>
                );
              })}
            </Table>
          </TableContainer>
          <PaginationTable
            page={state.page}
            perPage={state.perPage}
            collectionLength={state.orders.length}
            total={state.total}
            handleChangePage={handleChangePage}
            handleLastPage={handleLastPage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleFirstPage={handleFirstPage}
            title='Payments'
          />
          {bankedDialog.activePayment && (
            <Dialog open={bankedDialog.isOpen} onClose={closeBankedDialog}>
              <DialogContent>
                <BankedPayeeDialog
                  closeBankedDialog={closeBankedDialog}
                  payment={bankedDialog.activePayment}
                />
              </DialogContent>
            </Dialog>
          )}
        </Card>
      </Box>
    </>
  );
};
